// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { InterestFollowCircleButton } = require('client-v2/common/components/buttons')
const LazyImage = require('client-v2/common/components/lazy-image')
const { usePropsEventCallback } = require('client-v2/common/hooks/callbacks')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('InterestCard')

function InterestCard(props) {
  const { interest } = props
  const imageSources = React.useMemo(
    () => {
      if (interest['profile_image_urls']) {
        return [
          interest['profile_image_urls'].small,
          ...interest['profile_images']
        ]
      }
      return interest['profile_images']
    },
    [ interest['profile_image_urls'], interest['profile_images'] ]
  )
  const onCardClick = usePropsEventCallback(props, 'onCardClick')
  const onFollowClick = usePropsEventCallback(props, 'onFollowClick')
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('inner', {
          checked: interest.isFollowing
        }),
        onClick: onCardClick
      },
        tag(LazyImage, {
          className: bem.element('image'),
          sources: imageSources
        }),
        tag('span', {
          className: bem.element('name')
        },
          interest.name
        ),
        tag(InterestFollowCircleButton, {
          className: bem.element('follow-button'),
          checked: interest.isFollowing,
          onClick: onFollowClick
        })
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const InterestModelRecord = require('client-v2/common/models/interest/record')
  const PageContextRecord = require('client-v2/common/models/page-context/record')

  InterestCard.propTypes = {
    // Values
    className: PropTypes.string,
    interest: PropTypes.shape(InterestModelRecord.propTypes).isRequired,
    pageContext: PropTypes.shape(PageContextRecord.propTypes),
    // Callbacks
    onCardClick: PropTypes.func,
    onFollowClick: PropTypes.func
  }
}

module.exports = InterestCard
